import { Field } from "formik"

import Error from "@/components/Error/Error"
import RequiredInd from "@/components/RequiredInd/RequiredInd"

import styles from "./Inputs.module.css"

interface TextboxInputProps {
  label: string
  placeholder: string
  id: string
  name: string
  backError?: string
  error?: React.ReactNode
  className?: string
  row?: boolean
  required?: boolean
  as?: string
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
  value?: string
}

export default function TextboxInput({
  label,
  placeholder,
  id,
  name,
  backError,
  error,
  className,
  row,
  required,
  as,
  onChange,
  onBlur,
  value,
}: TextboxInputProps) {
  return (
    <div
      className={`inp-group flex-column text-inp d-flex ${
        row ? "flex-md-row align-items-md-center gap-3" : "flex-column gap-2"
      } w-100 ${className}`}
    >
      <div className="d-flex gap-2">
        <label className="m-0 modal__label fw-bold" htmlFor={id}>
          {label} {row ? ":" : ""}
        </label>{" "}
        {required ? <RequiredInd /> : ""}
      </div>
      <div className="w-100">
        {as == "field" ? (
          <TextBoxField placeholder={placeholder} name={name} id={id} />
        ) : (
          <TextBoxInp
            placeholder={placeholder}
            name={name}
            id={id}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
          />
        )}
        {<Error>{backError || error}</Error>}
      </div>
    </div>
  )
}

interface TextBoxFieldProps {
  placeholder: string
  name: string
  id: string
}
function TextBoxField({ placeholder, name, id }: TextBoxFieldProps) {
  return (
    <Field
      as="textarea"
      name={name}
      placeholder={placeholder}
      id={id}
      className={`${styles.input} ${styles["text-area"]} w-100`}
    />
  )
}

interface TextBoxInpProps {
  placeholder: string
  name: string
  id: string
  disabled?: boolean
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
  value?: string
}
function TextBoxInp({
  placeholder,
  name,
  id,
  disabled,
  onChange,
  onBlur,
  value,
}: TextBoxInpProps) {
  return (
    <textarea
      name={name}
      placeholder={placeholder}
      id={id}
      value={value || ""}
      className={`${styles.input} ${styles["text-box"]} w-100 mb-1`}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
    />
  )
}
